import {LanguageMenuModuleConfig} from "./language-menu-module.config";
import {LanguageMenuModuleState} from "./models/language-menu-module.state";
import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";

export class LanguageMenuModuleStore extends BaseMobxStore {
  static injectables = [LanguageMenuModuleConfig, LanguageMenuModuleState];
}